import React from "react";
import {
  Users,
  UserCheck,
  UsersRound,
  HandCoins,
  Globe,
  UserPlus,
} from "lucide-react";

const services = [
  {
    title: "Contingent Staffing",
    alink: "/contingent-staffing",
    description:
      "On-demand temporary staffing solutions for short-term roles or projects.",
    icon: <Users className="text-blue-600 w-10 h-10" />,
  },
  {
    title: "Direct Hire",
    alink: "/direct-hire",
    description:
      "Streamlined recruitment services to identify and place permanent employees.",
    icon: <UserCheck className="text-blue-600 w-10 h-10" />,
  },
  {
    title: "Nearshore / Onshore",
    alink: "/nearshore-onshore",
    description:
      "Strategic placement of skilled professionals in nearby locations.",
    icon: <UsersRound className="text-blue-600 w-10 h-10" />,
  },
  {
    title: "Global Payroll & Compliance",
    alink: "/global-payroll-compliance",
    description:
      "Simplifying payroll solutions by managing compensation, taxes, and compliance.",
    icon: <HandCoins className="text-blue-600 w-10 h-10" />,
  },
  {
    title: "Recruitment Process Outsource (RPO)",
    alink: "/recruitment-process-outsourcing",
    description:
      "Outsourced recruitment services offering end-to-end talent acquisition support.",
    icon: <Globe className="text-blue-600 w-10 h-10" />,
  },
  {
    title: "Statement of Work (SOW)",
    alink: "/statement-of-work",
    description:
      "Offering top-notch Statement of Work services to help you streamline your projects.",
    icon: <UserPlus className="text-blue-600 w-10 h-10" />,
  },
];

const ServicesSection = () => {
  return (
    <section className="py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="text-center border p-6 rounded-lg shadow-md hover:shadow-lg transition"
            >
              <div className="flex justify-center mb-4">{service.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
              <p className="text-gray-600 mb-4">{service.description}</p>
              <a
                href={service.alink}
                className="text-blue-600 font-semibold hover:underline inline-flex items-center"
              >
                Learn More →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
